/**
 * @description 批改-變更項目-是否需上傳證明
 */
export enum EndorseAttachmentType {
    /** 需要 */
    Required = '1',
    /** 不需要 */
    None = '0'
}